import { ApiException } from "@/exceptions/api.exception";
import { ChatApi } from "@/service/chat-api";
import { FeedbackApi } from "@/service/feedback-api";
import { ScanApi } from "@/service/scan-api";
import { StripeApi } from "../base/service/stripe-api";
import { UserApi } from "../base/service/user-api";
import { ProjectApi } from "./project-api";

const defaultHeaders = {
  "Content-Type": "application/json",
};

export class Client {
  baseUrl: string;

  constructor(baseUrl: string) {
    const savedEnv =
      typeof window !== "undefined" ? localStorage.getItem("apiEnv") : null;
    this.baseUrl =
      savedEnv === "beta" ? "https://api.beta.seoaipal.com" : baseUrl;
  }

  async fetch(url: string, init?: RequestInit): Promise<Response> {
    const headers = {
      ...defaultHeaders,
      ...(init?.headers || {}),
    };

    const uri = this.baseUrl + url;

    const response = await fetch(uri, {
      ...init,
      headers,
      credentials: "include",
    });

    console.log(
      "method:",
      init?.method ?? "GET",
      "request:",
      url,
      "response:",
      response.status
    );

    if (response.ok) {
      return response;
    }

    const json = await response.json();

    throw new ApiException(json.code, json.message);
  }
}

export const client = new Client(process.env.NEXT_PUBLIC_BACKEND_API_URL!);

export const stripeApi = new StripeApi(client);
export const userApi = new UserApi(client);
export const projectApi = new ProjectApi(client);
export const feedbackApi = new FeedbackApi(client);
export const scanApi = new ScanApi(client);
export const chatApi = new ChatApi(client);

if (typeof window !== "undefined") {
  window.beta = undefined;
  window.production = undefined;
  Object.defineProperty(window, "beta", {
    configurable: true,
    get: function () {
      client.baseUrl = "https://api.beta.seoaipal.com";
      localStorage.setItem("apiEnv", "beta");
      console.log("Switched to beta API");
      return undefined;
    },
  });
  Object.defineProperty(window, "production", {
    configurable: true,
    get: function () {
      client.baseUrl = process.env.NEXT_PUBLIC_BACKEND_API_URL!;
      localStorage.setItem("apiEnv", "production");
      console.log("Switched to production API");
      return undefined;
    },
  });
}

declare global {
  interface Window {
    beta: any;
    production: any;
  }
}
